module.exports = __webpack_public_path__ + "img/班鲁生产1.55b9aded.png";